import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/nav/friendship/page',
    method: 'get',
    params
  })
}

export function getById(id) {
  return request({
    url: `/nav/friendship/getById/${id}`,
    method: 'get'
  })
}

export function add(data) {
  return request({
    url: '/nav/friendship/',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/nav/friendship/',
    method: 'put',
    data
  })
}

export function remove(ids) {
  return request({
    url: `/nav/friendship/delete/${ids}`,
    method: 'delete'
  })
}

export function getMaxSort() {
  return request({
    url: '/nav/friendship/getMaxSort',
    method: 'get'
  })
}
